import { useMutation } from "@tanstack/react-query";
import { llmService } from "../services/llmService";
import { useNewton } from "../store/NewtonContext";
import { useInvalidate } from "../../../../../hooks/useInvalidate";

export function useLlmSessionCreate({ userId, onSuccess } = {}) {
  const { llmEnv, setSessionId } = useNewton();
  const invalidate = useInvalidate();

  return useMutation({
    mutationFn: async () => {
      return llmService.createSessionFnBackend({
        env: llmEnv,
        userId: userId,
      });
    },
    onSuccess: async (response) => {
      try {
        const text = await response.text();
        const parsed = JSON.parse(text);
        const sessionId = parsed.session_id;

        setSessionId(sessionId);
        invalidate(["getLlmSessions_key"]);
        if (typeof onSuccess === "function") onSuccess();
      } catch (err) {
        console.error("useLlmSessionCreate onSuccess error:", err);
      }
    },
  });
}
